<div class="modal-dialog modal-dialog_avatar-bonus">
  <div class="modal__content">
    <button class="modal__close"
      (click)="dialogRef.close()"
    ></button>

    <div class="avatar-bonus"
      [class.is-completed]="state.avatarCheckedUser()"
    >

    <img
      class="avatar-bonus__cop"
      src="/assets/images/bonuses-page/avatar-bonus/cop.webp"
      alt=""
    />
    <img
      class="avatar-bonus__cop mobile-view"
      src="/assets/images/bonuses-page/avatar-bonus/cop-mobile.webp"
      alt=""
    />

      @if (!state.avatarCheckedUser()) {
        <div class="avatar-bonus__content">
          <div class="avatar-bonus__title" i18n="@@bonuses.daily_rewards.avatar_bonus.title">Установи аватар</div>
          <div class="avatar-bonus__subtitle" i18n="@@bonuses.daily_rewards.avatar_bonus.subtitle">{{ data.modalDesc }}</div>

          <div class="avatar-bonus__conditions">
            <div class="avatar-bonus__condition condition">
              <div class="condition__title" i18n="@@bonuses.daily_rewards.avatar_bonus.step_1">1. Выбери аватар</div>
              <div class="condition__subtitle" i18n="@@bonuses.daily_rewards.avatar_bonus.step_1_text">Красивейшие аватары для тебя</div>

              <div class="condition__avatars">
                @for (avatar of data.avatars; track avatar.id) {
                  <div class="condition__avatar avatar-condition"
                    [class.is-active]="state.selectedAvatarId() === avatar.id"
                  >
                    <img class="image"
                      loading="lazy"
                      [src]="avatar.fileName | avatarUrl"
                      alt=""
                      (click)="selectAvatar(avatar.id)"
                    />

                    @if (state.selectedAvatarId() === avatar.id) {
                      <a class="avatar-condition__download link"
                        [href]="'/api/bonuses/avatars/'+ avatar.id +'/download'"
                        target="_blank"
                      >
                        <i class="icon icon_download-2"></i>
                      </a>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="avatar-bonus__condition condition">
              <div class="condition__head">
                <div class="condition__title" i18n="@@bonuses.daily_rewards.avatar_bonus.step_2">2. Установи аватар</div>

                <a class="condition__steam-link btn" href="https://steamcommunity.com/id/me/edit/avatar" target="_blank">
                  <span class="btn__text" i18n="@@bonuses.daily_rewards.avatar_bonus.step_2_button">Сменить аватар в STEAM</span>
                  <span class="icon icon_steam"></span>
                </a>
              </div>

              <div class="condition__profile-preview preview">
                <div class="preview__avatar">
                  @if (state.selectedAvatar(); as selectedAvatar) {
                    <img class="image"
                      loading="lazy"
                      [src]="selectedAvatar.fileName | avatarUrl"
                      alt=""
                    />
                  } @else {
                    <img class="image"
                      loading="lazy"
                      [src]="data.loggedUser | userAvatar:UserAvatarSize.MEDIUM:true"
                      alt=""
                    />
                  }
                </div>

                <div class="preview__nickname">
                  {{ data.loggedUser.nickname }}
                </div>
              </div>
            </div>
          </div>

          <button type="button" class="avatar-bonus__button btn"
            i18n="@@bonuses.daily_rewards.avatar_bonus.check_avatar"
            [disabled]="isCheckingAvatar()"
            [class.is-loading]="isCheckingAvatar()"
            (click)="checkAvatar()"
          >Проверить Аватар</button>
        </div>
      } @else {
        <div class="avatar-bonus__content">
          <div class="avatar-bonus__title" i18n="@@bonuses.daily_rewards.avatar_bonus.title">Условия участия</div>

          <div class="avatar-bonus__condition condition">
            <div class="condition__title" i18n="@@bonuses.daily_rewards.avatar_bonus.avatar_found_title">Вижу твой аватар!</div>
            <div class="condition__subtitle" i18n="@@bonuses.daily_rewards.avatar_bonus.24h_period">Дай мне 24 часа на проверку.</div>
          </div>

          @if (countdown$ | async; as countdown) {
            <div class="avatar-bonus__timer timer">
              <div class="timer__cell">
                <div class="timer__title">
                  {{ countdown.hours[0] }}
                </div>
                <div class="timer__subtitle">
                  {{ +countdown.hours[1] | i18nPlural:hoursPlurals }}
                </div>
              </div>
              <div class="timer__cell">
                <div class="timer__title">
                  {{ countdown.minutes[0] }}
                </div>
                <div class="timer__subtitle">
                  {{ +countdown.minutes[1] | i18nPlural:minutesPlurals }}
                </div>
              </div>
              <div class="timer__cell">
                <div class="timer__title">
                  {{ countdown.seconds[0] }}
                </div>
                <div class="timer__subtitle">
                  {{ +countdown.seconds[1] | i18nPlural:secondsPlurals }}
                </div>
              </div>
            </div>
          }

          <div class="avatar-bonus__warning warning">
            <div class="icon icon_clock"></div>
            <div class="warning__text" i18n="@@bonuses.daily_rewards.avatar_bonus.24h_period_warning">Для активации бонуса должно пройти около 24 часов.</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
